import { CalendarServiceType } from "@/apis/clients";
import { FC, memo } from "react";

interface Props {
  text: string;
  statusVal: CalendarServiceType;
  className?: string;
}

/**
 * 色指定
 * @param {CalendarServiceType} s
 */
function colorToClasses(s?: CalendarServiceType) {
  switch (s) {
    case CalendarServiceType.EVENT:
      return "bg-color-gray-50 text-white";
    case CalendarServiceType.CALENDAR:
      return "bg-[#0053AD] text-white";
  }
}

const CalendarServiceBudgeBase: FC<Props> = ({
  className,
  statusVal,
  text,
}) => {
  const classNames = [
    "flex justify-center items-center text-center rounded px-2 py-0.5 w-[80px] min-w-[80px] h-8 md:h-6",
    "text-xs font-bold leading-normal",
    colorToClasses(statusVal),
    className,
  ].join(" ");

  return <span className={classNames}>{text}</span>;
};

export const CalendarServiceBudge = memo(CalendarServiceBudgeBase);
